import getPercentageOfBookForMarkers from '../getPercentageOfBookForMarkers';

/**
 * @method getOfflineSessionPercentageWithAdditionalMarkers
 * @param {UserContentOfflineSession} offlineSession - an offline session, or null for no session
 * @param {Array<BookMarker>} additionalMarkers - a list of BookMarker objects
 */
const getOfflineSessionPercentageWithAdditionalMarkers = (
  offlineSession = null,
  additionalMarkers = [],
) => {
  const existingMarkers = offlineSession?.markers ?? [];

  return getPercentageOfBookForMarkers([
    ...existingMarkers,
    ...additionalMarkers,
  ]);
};

export default getOfflineSessionPercentageWithAdditionalMarkers;
